// Extensions per file category — used when AllowedExtensions is not explicitly configured
export const IMAGE_EXTENSIONS = '.jpg,.jpeg,.png,.gif,.svg,.webp,.bmp,.tiff,.ico';
export const DOCUMENT_EXTENSIONS = '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.rtf,.csv';
export const VIDEO_EXTENSIONS = '.mp4,.mov,.avi,.wmv,.mkv,.webm';
export const ARCHIVE_EXTENSIONS = '.zip,.rar,.tar,.gz,.7z';
/**
 * Builds a comma-separated accept string from workflow file restrictions.
 * Returns null if no file types are allowed.
 */
export function buildAcceptString(restrictions) {
    // 1. Check category booleans first — these are the primary source
    const parts = [];
    if (restrictions.AllowImages)
        parts.push(IMAGE_EXTENSIONS);
    if (restrictions.AllowDocuments)
        parts.push(DOCUMENT_EXTENSIONS);
    if (restrictions.AllowVideos)
        parts.push(VIDEO_EXTENSIONS);
    if (restrictions.AllowArchives)
        parts.push(ARCHIVE_EXTENSIONS);
    if (parts.length > 0)
        return parts.join(',');
    // 2. No categories enabled — fall back to AllowedExtensions if configured
    if (restrictions.AllowedExtensions && restrictions.AllowedExtensions.length > 0) {
        return restrictions.AllowedExtensions
            .map(ext => ext.startsWith('.') ? ext : `.${ext}`)
            .join(',');
    }
    // 3. Nothing enabled — no file types are allowed
    return null;
}
